import { defineMessages } from 'react-intl';

export default defineMessages({
    tellsUsAboutYourself: {
        id: 'ml.quoteandbind.common.YourInfo.Before we start, tell us about yourself',
        defaultMessage: 'Before we start, tell us about yourself',
    },
    dateOfBirth: {
        id: 'ml.quoteandbind.common.YourInfo.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    emailAddress: {
        id: 'ml.quoteandbind.common.YourInfo.Email Address',
        defaultMessage: 'Email Address'
    },
    whyDoYouNeedThis: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Why do you need this?',
        defaultMessage: 'Why do you need this?'
    },
    needInformationForAccurateQuote: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Need information to provide accurate quote',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    },
    whatWillWeEmailYou: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.What will we email you?',
        defaultMessage: 'What will we email you?'
    },
    emailTooltipText: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Email Tooltip Text',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes. To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    emailTooltipTextQb: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Email Tooltip TextQb',
        defaultMessage: 'When you provide your email address, you will receive emails about your online quote and other product information from us and third parties working for us who we gave your email address. We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes. To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    coveregeEffectiveDate: {
        id: 'ml.quoteandbind.common.YourInfo.Coverage Effective Date',
        defaultMessage: 'Coverage Effective Date',
    },
    whatDateShouldIChoose: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.What date should I choose?',
        defaultMessage: 'What date should I choose?'
    },
    chooseExpirationDateOfExistingCoverage: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Choose the expiration date of existing coverage',
        defaultMessage: 'Choose the expiration date of your existing coverage or a date as soon as tomorrow or up to 90 days in the future.'
    },
    chooseExpirationDateOfExistingCoverageQb: {
        id: 'ml.quoteandbind.common.YourInfo.tooltip.Choose the effective date of your new rental agreement',
        defaultMessage: 'Choose the effective date of your new rental agreement, or the expiration date of your existing policy Or choose any date as soon as tomorrow or up to 90 days in the future.'
    },
    yourAddress: {
        id: 'ml.quoteandbind.common.YourInfo.Your Address',
        defaultMessage: 'Your Address',
    },
    yourAddressHOTooltipText: {
        id: 'ml.quoteandbind.common.YourInfo.ho.tooltip.Enter the address of the property you are insuring',
        defaultMessage: 'Enter the address of the property you are insuring',
    },
    yourAddressPATooltipText: {
        id: 'ml.quoteandbind.common.YourInfo.pa.tooltip.Enter the address where your vehicle is parked or garaged',
        defaultMessage: 'Enter the address where your vehicle is parked or garaged',
    },
    yourAddressPUPTooltipText: {
        id: 'ml.quoteandbind.common.YourInfo.pup.tooltip.Enter the address where your vehicle is parked or garaged',
        defaultMessage: 'Enter your primary residence address',
    },
    typeHereToSearchForAddress: {
        id: 'ml.quoteandbind.common.YourInfo.Type here to search for address',
        defaultMessage: 'Type here to search for address (No PO Box)'
    },
    informationLookup: {
        id: 'ml.quoteandbind.common.YourInfo.Information Lookup',
        defaultMessage: 'To save your time, we will look up your information'
    },
    informationLookupLink:{
        id: 'ml.quoteandbind.common.YourInfo.Information Lookup Link',
        defaultMessage: 'See notice of information practices for additional details'
    },
    informationFromPublicRecords: {
        id: 'ml.quoteandbind.common.YourInfo.Information from public records',
        defaultMessage: 'We get this information from public records. You will have the opportunity to edit this information next.'
    },
     explicitConsent1: {
        id: 'ml.quoteandbind.common.YourInfo.By clicking Agree and submit',
        defaultMessage: 'By clicking Agree and submit, you agree to these '
    },
    explicitConsent2: {
        id: 'ml.quoteandbind.common.YourInfo.ESIGN terms and conditions',
        defaultMessage: 'ESIGN terms and conditions '
    },
    explicitConsent3: {
        id: 'ml.quoteandbind.common.YourInfo.and to receive marketing calls and texts',
        defaultMessage: 'and to receive marketing calls and texts as detailed below '
    },
     explicitConsent4: {
        id: 'ml.quoteandbind.common.YourInfo. We call and/or text consumers with information',
        defaultMessage: ' We call and/or text consumers with information about products and services. By clicking “Agree and submit”, you consent to receive marketing calls and texts on behalf of Farmers®, Foremost®, Bristol West®, and Farmers Life® '
    },
    explicitConsent5: {
        id: 'ml.quoteandbind.common.YourInfo.associated entities',
        defaultMessage: 'associated entities '
    },
    explicitConsent6: {
        id: 'ml.quoteandbind.common.YourInfo.and their representatives using',
        defaultMessage: ' and their representatives using an automated telephone dialing system, AI-generated and artificial or pre-recorded voice, even for numbers listed on national, state, or business do-not-call registries. Consent is not a condition of purchase. Go to Farmers.com for alternative contact options. Message and data rates may apply'
    },
    Continue: {
        id: 'ml.quoteandbind.common.YourInfo.Continue',
        defaultMessage: 'CONTINUE'
    },
    agreeAndSubmit: {
        id: 'ml.quoteandbind.common.YourInfo.Agree and Submit',
        defaultMessage: 'Agree and Submit'
     },
    verifyEligibilityNext: {
        id: 'ml.quoteandbind.common.YourInfo.We\'ll verify eligibility next',
        defaultMessage: 'We\'ll {verifyEligibility} next'
    },
    verifyEligibility: {
        id: 'ml.quoteandbind.common.YourInfo.verify eligibility',
        defaultMessage: 'verify eligibility'
    },
    findVehiclesAndDrivers: {
        id: 'ml.quoteandbind.common.YourInfo.We\'ll find your vehicles and drivers next',
        defaultMessage: 'We\'ll find your {driversAndVehicles} next'
    },
   findemployerAndAffiliations: {
        id: 'ml.quoteandbind.common.YourInfo.We\'ll find employerAndAffiliations next',
        defaultMessage: 'We\'ll find your {employerAndAffiliations} next'
    },
    driversAndVehicles: {
        id: 'ml.quoteandbind.common.YourInfo.vehicles & drivers',
        defaultMessage: ' vehicles & drivers',
    },
    employerAndAffiliations: {
        id: 'ml.quoteandbind.common.YourInfo.employer and affiliations',
        defaultMessage: ' employer and affiliations',
    },
    mailingAddress: {
        id: 'ml.quoteandbind.common.YourInfo.mailingAddress.Is your current mailing address the same as the property address listed above?',
        defaultMessage: 'Is your current mailing address the same as the property address listed above?'
    },
    policyAddrStreetLabel: {
        id: 'ml.quoteandbind.common.YourInfo.addressDetails.Street Address',
        defaultMessage: 'Street Address'
    },
    policyAddrSearchLabel: {
        id: 'ml.quoteandbind.common.YourInfo.addressDetails.Enter street address (No PO Box)',
        defaultMessage: 'Enter street address (No PO Box)'
    },
    policyAddrBottomLabel: {
        id: 'ml.quoteandbind.common.YourInfoaddressDetails.Enter your current address here',
        defaultMessage: 'Enter your current address here'
    },
    mailingAddressLabel: {
        id: 'ml.quoteandbind.common.YourInfo.mailingAddress.Mailing address',
        defaultMessage: 'Mailing Address'
    },
    mailingAddrStreetLabel: {
        id: 'ml.quoteandbind.common.YourInfo.mailingAddress.Street Address or PO BOX',
        defaultMessage: 'Street Address or PO BOX'
    },
    mailingAddrSearchLabel: {
        id: 'ml.quoteandbind.common.YourInfo.mailingAddress.Enter Mailing Address',
        defaultMessage: 'Enter Mailing Address'
    },
    mailingAddrPopulatedAddressLabel: {
        id: 'ml.quoteandbind.common.YourInfo.mailingAddress.Mailing Address populated below',
        defaultMessage: 'Mailing Address populated below'
    },
    productNotAvailable: {
        id: 'ml.quoteandbind.common.YourInfo.Digital Product Not Available',
        defaultMessage: 'We\'re sorry, our digital { product } policy is not available in your state. Please call us at { phoneNum } to complete a quote.'
    },
    closeWindow: {
        id: 'ml.quoteandbind.common.YourInfo.Close Window',
        defaultMessage: 'Close Window'
    },
    technicalDifficulties: {
        id: 'ml.quoteandbind.common.YourInfo.technical difficulties',
        defaultMessage: 'We’re sorry. Due to technical difficulties, we are unable to process your quote at this time. Please try again later. Thank you.'
    },
    policyAddrHOBottomLabel: {
        id: 'ml.quoteandbind.common.YourInfoaddressDetails.Enter the address of the property to be insured',
        defaultMessage: 'Enter the address of the property to be insured'
    },
    hoprentalEffectiveDateTooltip: {
        id: 'ml.quoteandbind.common.YourInfo.What date should I choose renter tooltip',
        defaultMessage: 'Choose the effective date of your new rental agreement, or the expiration date of your existing coverage.  Or choose any date as soon as tomorrow or up to 90 days in the future.'
    },
    hoEffectiveDateTooltip: {
        id: 'ml.quoteandbind.common.YourInfo.What date should I choose home/condo tooltip',
        defaultMessage: 'Choose the date the closing is scheduled for your new home, or the expiration date of your existing coverage.  Or choose a date as soon as tomorrow or up to 90 days in the future.'
    },
    propertyAddressLabel: {
        id: 'ml.quoteandbind.common.YourInfo.ho.Property Address',
        defaultMessage: 'Property Address'
    },
    yourAddressLabel: {
        id: 'ml.quoteandbind.common.YourInfo.ho.Your Address',
        defaultMessage: 'Your Address'
    },
    blankCommon: {
        id: 'ml.quoteandbind.common.YourInfo.contact-details.Blank',
        defaultMessage: ' '
    },
    nameCommon: {
        id: 'ml.quoteandbind.common.YourInfo.contact-details.Name',
        defaultMessage: 'Name'
    },
    firstNameCommon: {
        id: 'ml.quoteandbind.common.YourInfo.contact-details.First name',
        defaultMessage: 'First name'
    },
    lastNameCommon: {
        id: 'ml.quoteandbind.common.YourInfo.contact-details.Last name',
        defaultMessage: 'Last name'
    },
    middleNameCommon: {
        id: 'ml.quoteandbind.common.YourInfo.contact-details.Middle name',
        defaultMessage: 'Middle name'
    },
    chooseNamedInsuredML: {
        id: 'ml.quoteandbind.common.YourInfo.Choose the name of the person who will be the named insured on this quote',
        defaultMessage: 'Choose the name of the person who will be the named insured on this quote'
    },
    updateInfoBelowML: {
        id: 'ml.quoteandbind.common.YourInfo.Update information for the selected policyholder below',
        defaultMessage: 'Update information for the selected policyholder below'
    },
    SNIAndPNICannotBeTheSameContactML: {
        id: 'ml.quoteandbind.common.YourInfo.The primary and secondary name cannot be the same person',
        defaultMessage: 'The primary and secondary named insured cannot be the same person'
    },
    invalidEmail:{
        id:'ml.quoteandbind.common.YourInfo.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    mlPhoneNumber: {
        id: 'ml.quoteandbind.common.YourInfo.mlPhoneNumber',
        defaultMessage: '1-844-438-8430'
    },
    noAlphaNumeric_ML: {
        id: 'ml.quoteandbind.common.YourInfo.onlyAlphaCharacters',
        defaultMessage: 'Only alpha characters may be entered in this field'
    },
    searchLabel: {
        id: "ml.quoteandbind.common.YourInfo.addressDetails.Street Address (No Post Office Boxes)",
        defaultMessage: "Street Address (No Post Office Boxes)"
    },
    ssnMsgOtherState: {
        id: "ml.quoteandbind.common.YourInfo.ssnMsgOtherState",
        defaultMessage: "In connection with this application for insurance, we may review your and your spouse’s credit report or obtain or use a credit-based insurance score based on the information contained in that credit report. We may use third parties in connection with the development of your insurance scores based on data from traditional credit bureaus and the National Consumer Telecom & Utilities Exchange database."
    },
    ssnMsgOrState: {
        id: "ml.quoteandbind.common.YourInfo.ssnMsgOrState",
        defaultMessage: "In connection with this application for insurance, we may review your and your spouse’s credit report or obtain or use a credit-based insurance score based on the information contained in that credit report. We may use third parties in connection with the development of your insurance scores based on data from traditional credit bureaus and the National Consumer Telecom & Utilities Exchange database. You may request that we give you a written statement describing our use of credit history and insurance scores."
    },
    ssnMsgTxState: {
        id: "ml.quoteandbind.common.YourInfo.ssnMsgTxState",
        defaultMessage: "We will obtain and use credit information, from traditional credit bureaus and the National Consumer Telecom & Utilities Exchange database, on you [and your spouse] as a part of the insurance credit scoring process."
    }
});
